<section class="dataspace-layout">
  <header class="dataspace-layout__header">
    <div>
      <h2>{{ title }}</h2>
      <p *ngIf="subtitle">{{ subtitle }}</p>
    </div>

    <div class="dataspace-layout__stats" *ngIf="stats.length">
      <div class="dataspace-layout__stat" *ngFor="let stat of stats">
        <span class="dataspace-layout__stat-value">{{ stat.value }}</span>
        <span class="dataspace-layout__stat-label">{{ stat.label }}</span>
      </div>
    </div>
  </header>

  <div class="dataspace-layout__grid">
    <aside class="dataspace-layout__sidebar">
      <ng-content select="[workspace-sidebar]"></ng-content>
    </aside>

    <section class="dataspace-layout__detail">
      <ng-content select="[workspace-detail]"></ng-content>
    </section>
  </div>
</section>
